export default __webpack_public_path__ + "static/media/640_business05-jp-mobile.4dd5ec15.png";